export const PAYLOAD_TOO_LARGE_MESSAGE =
    'The file is too large. Please upload a smaller image.'

function isHtmlPayload(data) {
    if (typeof data !== 'string') return false
    const sample = data.trim().slice(0, 200).toLowerCase()
    return sample.startsWith('<!doctype') || sample.startsWith('<html') || sample.includes('nginx')
}

export function getApiErrorMessage(error, fallback = 'Something went wrong') {
    const status = error?.response?.status
    if (status === 413) return PAYLOAD_TOO_LARGE_MESSAGE

    const data = error?.response?.data
    if (data && typeof data === 'object' && data.error) return data.error
    if (typeof data === 'string' && data && !isHtmlPayload(data)) return data

    const message = error?.message || ''
    if (message && !/^Request failed with status code \d+$/i.test(message)) {
        return message
    }

    return fallback
}

export function normalizeAxiosError(error) {
    if (!error) return error

    const message = getApiErrorMessage(error, error.message || PAYLOAD_TOO_LARGE_MESSAGE)
    error.message = message

    if (error.response && (error.response.status === 413 || isHtmlPayload(error.response.data))) {
        error.response.data = { success: false, error: message }
    }

    return error
}
